import { Link } from "react-router-dom";
import { useSiteSettings } from "@/lib/useSiteSettings";

export default function QuickAccessSection() {
  const siteConfig = useSiteSettings();
  const items = [
    {
      icon: "ri-bank-card-line",
      title: "Pagar cuenta",
      desc: "Paga tu cuenta de agua en linea de forma rapida y segura.",
      color: "bg-sky-500",
      href: "/pagar",
      external: false,
      cta: "Ir a pagar",
    },
    {
      icon: "ri-user-line",
      title: "Portal usuarios",
      desc: "Revisa tu consumo, historial de pagos y datos de tu cuenta.",
      color: "bg-emerald-500",
      href: siteConfig.portalUrl,
      external: true,
      cta: "Ingresar",
    },
    {
      icon: "ri-alarm-warning-line",
      title: "Reportar problema",
      desc: "Informa sobre fugas, cortes no programados u otras emergencias.",
      color: "bg-orange-500",
      href: "/contacto",
      external: false,
      cta: "Contactar",
    },
    {
      icon: "ri-newspaper-line",
      title: "Comunicados",
      desc: "Revisa los ultimos avisos, cortes programados y comunicados oficiales.",
      color: "bg-violet-500",
      href: "/comunicados",
      external: false,
      cta: "Ver comunicados",
    },
  ];

  return (
    <section className="py-20 px-4 md:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="text-sky-500 text-sm font-semibold uppercase tracking-wider">Accesos directos</span>
          <h2
            className="text-3xl md:text-4xl font-extrabold text-sky-900 mt-1"
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            Que necesitas hacer hoy?
          </h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {items.map((item) => (
            item.external ? (
              <a
                key={item.title}
                href={item.href}
                className="group flex flex-col items-start p-6 rounded-2xl border border-slate-100 hover:border-sky-200 hover:shadow-md transition-all duration-300 cursor-pointer bg-white"
              >
                <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${item.color} text-white mb-4`}>
                  <i className={`${item.icon} text-2xl`}></i>
                </div>
                <h3 className="font-bold text-sky-900 text-base mb-2">{item.title}</h3>
                <p className="text-slate-500 text-sm leading-relaxed flex-1">{item.desc}</p>
                <span className="mt-4 text-sky-600 text-sm font-semibold flex items-center gap-1 group-hover:gap-2 transition-all">
                  {item.cta} <i className="ri-arrow-right-line"></i>
                </span>
              </a>
            ) : (
              <Link
                key={item.title}
                to={item.href}
                className="group flex flex-col items-start p-6 rounded-2xl border border-slate-100 hover:border-sky-200 hover:shadow-md transition-all duration-300 cursor-pointer bg-white"
              >
                <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${item.color} text-white mb-4`}>
                  <i className={`${item.icon} text-2xl`}></i>
                </div>
                <h3 className="font-bold text-sky-900 text-base mb-2">{item.title}</h3>
                <p className="text-slate-500 text-sm leading-relaxed flex-1">{item.desc}</p>
                <span className="mt-4 text-sky-600 text-sm font-semibold flex items-center gap-1 group-hover:gap-2 transition-all">
                  {item.cta} <i className="ri-arrow-right-line"></i>
                </span>
              </Link>
            )
          ))}
        </div>
      </div>
    </section>
  );
}
